import { ActionTree } from 'vuex';
import { ClaimsState } from './types';
import { RootState } from '@/types';
import { claimService } from '@/services/claim.services';


export const actions: ActionTree<ClaimsState, RootState> = {
    get({ commit }, {
        page = 1,
        perPage = 10,
        search = '',
        archived = false,
        sortBy = '',
        sortDesc = false,
    }): any {
        commit('setLoading');
        claimService.index(page, perPage, search, archived, sortBy, sortDesc)
        .then((response) => {
            const payload: any = response && response.data;
            commit('setData', payload);
        }, (error) => {
            commit('setError', error);
        });
    },
    post({ dispatch }, {
        claim, page = 1,
        perPage = 10,
        search = '',
        archived = false,
        sortBy = '',
        sortDesc = false,
    }): any {
        let post;
        if (claim.id) {
            post = claimService.put(claim.id, claim);
        } else {
            post = claimService.post(claim);
        }
        post.then(() => {
            dispatch('get', { page, perPage, search, archived, sortBy, sortDesc });
        });
    },

};
